const DAY = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });

/** `2026-10-11T15:30:00.000Z` → `2026-10-11 15:30 UTC` (the console shows UTC everywhere). */
export function formatTime(iso: string): string {
  return `${iso.slice(0, 16).replace('T', ' ')} UTC`;
}

/** `2026-10-11T15:30:00.000Z` → `11 Oct`. */
export function formatDay(iso: string): string {
  return DAY.format(new Date(iso));
}

/** A timestamp as `<time>`, or a fallback text when missing. */
export function Time({ iso, missing = '—' }: { iso: string | null; missing?: string }) {
  if (!iso) return <>{missing}</>;
  return <time dateTime={iso}>{formatTime(iso)}</time>;
}
